module.exports = __webpack_public_path__ + "static/media/bike.fd5d3bc0.svg";